namespace SorAraBul.Administration {

    @Serenity.Decorators.registerClass()
    export class PurchasePackageFeaturesGrid extends Serenity.EntityGrid<PurchasePackageFeaturesRow, any> {
        protected getColumnsKey() { return PurchasePackageFeaturesColumns.columnsKey; }
        protected getDialogType() { return PurchasePackageFeaturesDialog; }
        protected getIdProperty() { return PurchasePackageFeaturesRow.idProperty; }
        protected getInsertPermission() { return PurchasePackageFeaturesRow.insertPermission; }
        protected getLocalTextPrefix() { return PurchasePackageFeaturesRow.localTextPrefix; }
        protected getService() { return PurchasePackageFeaturesService.baseUrl; }
        protected getIsActiveProperty() { return PurchasePackageFeaturesRow.isActiveProperty; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}
